import AccountForm from './AccountForm'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose } from 'recompose'
import { withCookies } from 'react-cookie'
import * as authSelectors from '../../../selectors/auth'
import { logIn, signUp } from '../../../store/effects/auth'

const mapStateToProps = state => ({
  userIsLoggedIn: authSelectors.userIsLoggedIn(state),
  userIsLogginIn: authSelectors.userIsLogginIn(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logIn,
      signUp
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withCookies
)(AccountForm)



// WEBPACK FOOTER //
// ./src/modules/Checkout/AccountForm/index.js